import qs from "qs";

export async function get(endpoint: string, params: Object = {}) {
  const pathString: string = endpoint + "?" + qs.stringify(params);
  try {
    const res = await fetch(pathString, { method: "GET" });
    if (!res.ok) return null;
    const jsonified = await res.json();
    return jsonified;
  } catch (error) {
    console.log(`GET request to ${pathString} failed!\n${error}`);
    return null;
  }
}
export async function post(endpoint: string, body: Object = {}) {
  try {
    const res = await fetch(endpoint, {
      body: JSON.stringify(body),
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
    });
    if (!res.ok) return null;
    const jsonified = await res.json();
    return jsonified;
  } catch (error) {
    console.log(`POST req to ${endpoint} failed:\n${error}`);
    return null;
  }
}

export const STADIUMS = {
  ATL: "State Farm Arena",
  BKN: "Barclays Center",
  BOS: "TD Garden",
  CHA: "Spectrum Center",
  CHI: "United Center",
  CLE: "Rocket Mortgage Fieldhouse",
  DAL: "American Airlines Center",
  DEN: "Pepsi Center",
  DET: "Little Caesars Arena",
  GSW: "Chase Center",
  HOU: "Toyota Center",
  IND: "Bankers Life Fieldhouse",
  LAC: "Staples Center",
  LAL: "Staples Center",
  MEM: "FedEx Forum",
  MIA: "American Airlines Arena",
  MIL: "Fiserv Forum",
  MIN: "Target Center",
  NOP: "Smoothie King Center",
  NYK: "Madison Square Garden",
  OKC: "Chesapeake Energy Arena",
  ORL: "Amway Center",
  PHI: "Wells Fargo Center",
  PHX: "Talking Stick Resort Arena",
  POR: "Moda Center",
  SAC: "Golden 1 Center",
  SAS: "AT&T Center",
  TOR: "Scotiabank Arena",
  UTA: "Vivint Smart Home Arena",
  WAS: "Capital One Arena",
};
export const CITIES = {
  ATL: "Atlanta, GA",
  BKN: "Brooklyn, NY",
  BOS: "Boston, MA",
  CHA: "Charlotte, NC",
  CHI: "Chicago, IL",
  CLE: "Cleveland, OH",
  DAL: "Dallas, TX",
  DEN: "Denver, CO",
  DET: "Detroit, MI",
  GSW: "San Francisco, CA",
  HOU: "Houston, TX",
  IND: "Indianapolis, IN",
  LAC: "Los Angeles, CA",
  LAL: "Los Angeles, CA",
  MEM: "Memphis, TN",
  MIA: "Miami, FL",
  MIL: "Milwaukee, WI",
  MIN: "Minneapolis, MN",
  NOP: "New Orleans, LA",
  NYK: "New York City, NY",
  OKC: "Oklahoma City, OK",
  ORL: "Orlando, FL",
  PHI: "Philadelphia, PA",
  PHX: "Phoenix, AZ",
  POR: "Portland, OR",
  SAC: "Sacramento, CA",
  SAS: "San Antonio, TX",
  TOR: "Toronto, ON",
  UTA: "Salt Lake City, UT",
  WAS: "Washington, D.C.",
};

const ESPN_ABBREVS = { nop: "no", uta: "utah" } as const;

export const getLogo = (team: string, size: string | number) => {
  const lower = team.toLowerCase();
  const espnName = ESPN_ABBREVS[lower] ?? lower;
  return `https://a.espncdn.com/combiner/i?img=/i/teamlogos/nba/500/scoreboard/${espnName}.png&scale=crop&location=origin&w=${size}&h=${size}`;
};

const BBREF_SCORE_BASE = "https://www.basketball-reference.com/boxscores/";
export const getBoxScore = (date: Date, home: string) => {
  const dateString = date.toISOString().split("T")[0].replace(/-/g, "");
  return `${BBREF_SCORE_BASE}${dateString}0${home}.html`;
};

const POINTS = {
  0: 15,
  1: 12,
  2: 10,
  3: 8,
  4: 7,
  5: 6,
  6: 5,
  7: 4,
  8: 3,
  9: 2,
  10: 1,
} as const;

export function awardPoints(guessed, actual, correct) {
  if (!correct) {
    return [0, 0];
  }
  const diff = Math.abs(guessed - actual);
  return [15, POINTS[diff] ?? 0];
}
